exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".page-wrapper[data-v-0bdc7a10]{width:100%}.page-wrapper[data-v-0bdc7a10],.profile-wrapper[data-v-0bdc7a10]{display:flex;flex-direction:column}.profile-wrapper[data-v-0bdc7a10]{align-self:center;border-radius:10px;width:80%;background-color:#fff;margin-top:50px}@media (max-width:1000px){.profile-wrapper[data-v-0bdc7a10]{width:95%}}", ""]);

// exports
